import "./edit-visit.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormVisit from "../form-visit/form-visit";
import { useEditVisit } from "./edit-visit.hook";
import FormVisitAttachment from "../form-visit-attachment/form-visit-attachment";
import { TabPanel, TabView } from "primereact/tabview";
import { Button } from "primereact/button";

export function EditVisit() {
  const {
    visitData,
    isLoading,
    visitError,
    formMethod,
    actions,
    handleBack,
    handleAction,
    handlePaySession,
    summary,
  } = useEditVisit();

  const title = <h3>Edit Visit</h3>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <TabView>
        <TabPanel header="Information">
          <FormVisit />
        </TabPanel>
        <TabPanel header="Attachments">
          <FormVisitAttachment />
        </TabPanel>
      </TabView>
    </div>
  );

  return (
    <div id="EditVisit" className="visit">
      <HeaderContent
        title={title}
        className="bg-slate-200"
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <div className="flex justify-between items-end w-full gap-4">
          <div className="flex flex-col items-start">
            <Button
              label="Pay session"
              onClick={handlePaySession}
              className="mt-2"
            />
          </div>
          <HeaderButton actions={actions} onAction={handleAction} />
        </div>
      </HeaderContent>
      {summary}

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {visitError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditVisit;
